import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyBauhausMode({ brand }: ModeRendererProps) {
  // Functional abstraction and form-follows-function clarity
  // Basic shapes: circle, square, triangle with functional color
  
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.paper} />
      
      {/* Primary Bauhaus shapes - large scale */}
      {/* Circle */}
      <circle cx="200" cy="200" r="120" fill={brand.aqua} opacity={0.8} />
      
      {/* Square */}
      <rect x="340" y="80" width="240" height="240" fill={brand.violet} opacity={0.8} />
      
      {/* Triangle */}
      <polygon
        points="650,320 550,120 750,120"
        fill={brand.amber}
        opacity={0.8}
      />
      
      {/* Vasarely optical treatment on circle */}
      {Array.from({ length: 8 }).map((_, i) => {
        const r = 110 - i * 14;
        return (
          <circle
            key={`circle-optical-${i}`}
            cx="200"
            cy="200"
            r={r}
            fill="none"
            stroke={i % 2 === 0 ? brand.deep : brand.white}
            strokeWidth="3"
            opacity={0.7}
          />
        );
      })}
      
      {/* Optical grid on square */}
      {Array.from({ length: 8 }).map((_, row) =>
        Array.from({ length: 8 }).map((_, col) => (
          <rect
            key={`square-grid-${row}-${col}`}
            x={350 + col * 28}
            y={90 + row * 28}
            width={26}
            height={26}
            fill={
              (row + col) % 2 === 0
                ? brand.deep
                : (row + col) % 3 === 0
                ? brand.white
                : brand.aqua
            }
            opacity={0.6}
          />
        ))
      )}
      
      {/* Middle section - functional composition */}
      <rect x="80" y="380" width="180" height="180" fill={brand.deep} opacity={0.9} />
      <circle cx="170" cy="470" r="70" fill={brand.amber} opacity={0.7} />
      
      <rect x="300" y="380" width="180" height="90" fill={brand.aqua} opacity={0.7} />
      <rect x="300" y="490" width="180" height="70" fill={brand.violet} opacity={0.7} />
      
      <polygon
        points="520,560 520,380 640,470"
        fill={brand.amber}
        opacity={0.8}
      />
      
      {/* Concentric triangles */}
      {Array.from({ length: 5 }).map((_, i) => {
        const scale = 1 - i * 0.15;
        const offset = i * 15;
        return (
          <polygon
            key={`triangle-${i}`}
            points={`${640 - offset},${560 - offset} ${640 - offset},${380 + offset} ${520 + offset},${470}`}
            fill="none"
            stroke={brand.deep}
            strokeWidth="2"
            opacity={0.5}
          />
        );
      })}
      
      {/* Lower section - geometric field */}
      {Array.from({ length: 6 }).map((_, row) =>
        Array.from({ length: 8 }).map((_, col) => {
          const x = 80 + col * 80;
          const y = 620 + row * 70;
          const shape = (row + col) % 3;
          
          if (shape === 0) {
            return (
              <circle
                key={`shape-${row}-${col}`}
                cx={x + 35}
                cy={y + 35}
                r="30"
                fill={brand.aqua}
                opacity={0.6}
              />
            );
          } else if (shape === 1) {
            return (
              <rect
                key={`shape-${row}-${col}`}
                x={x + 5}
                y={y + 5}
                width="60"
                height="60"
                fill={brand.violet}
                opacity={0.6}
              />
            );
          } else {
            return (
              <polygon
                key={`shape-${row}-${col}`}
                points={`${x + 35},${y + 5} ${x + 5},${y + 65} ${x + 65},${y + 65}`}
                fill={brand.amber}
                opacity={0.6}
              />
            );
          }
        })
      )}
      
      {/* Thin lines for structure */}
      {Array.from({ length: 12 }).map((_, i) => (
        <line
          key={`line-h-${i}`}
          x1="80"
          y1={620 + i * 70}
          x2="720"
          y2={620 + i * 70}
          stroke={brand.deep}
          strokeWidth="1"
          opacity={0.2}
        />
      ))}
      
      {Array.from({ length: 9 }).map((_, i) => (
        <line
          key={`line-v-${i}`}
          x1={80 + i * 80}
          y1="620"
          x2={80 + i * 80}
          y2="1040"
          stroke={brand.deep}
          strokeWidth="1"
          opacity={0.2}
        />
      ))}
    </g>
  );
}
